import React, { useEffect, useRef, useState } from "react";
import { Dropdown, Tab, ButtonGroup, DropdownButton } from 'react-bootstrap'
import { useAppSelector, useAppDispatch } from "../../app/hooks";
import { Link, useLocation } from 'react-router-dom';
import { json } from "stream/consumers";
import clsx from 'clsx';
import { KTIcon, KTSVG, toAbsoluteUrl } from '../../_metronic/helpers';
import { ShowSwalWithConfirmation } from '../../common/SweetAlert';
import CustomPagination from "../../common/Pagination";
import { ShowToast } from "../../common/Toastr";
import fetchAPI from "../../common/fetchAPI";
import Select, { StylesConfig } from 'react-select';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { DateRangePicker } from 'rsuite';
import 'rsuite/dist/rsuite.css';
import { useTranslation } from "react-i18next";
import { formatDateWithDateAndMonthName, getValueFromResource,formatDateWithTZ } from "../../common/timeLiveFunction";
/* import { formatDateWithDateAndMonthName } from '../../common/timesheetFunction'; */
import { format, parse } from 'date-fns';
import moment from "moment";
import CanvasLoader from "../../common/CanvasLoader";
import { getAccountEmployeeTimeEntryDetailsAsync } from "../audit/AccountAuditSlice";
import { data } from "jquery";
import { submittedTimesheetAsync } from "./timesheetSlice";
const itemClass = 'ms-1 ms-lg-0';

const TimeSheetApprovalDetails = (props: any) => {
    const dispatch = useAppDispatch();
    const [detail, setDetail] = useState<any>([]);
    const { t } = useTranslation();
    const { accountEmployeeTimeEntryPeriodId, accountEmployeeId, isLoading, isApprovalDetail, timeEntryPeriodIdForApproval } = useAppSelector((state) => state.timesheet);
    const { cultureInfoName, CurrentCultureDateFormat,ProfileTimeZoneIANA } = useAppSelector((state) => state.globalState);
    const currentDate = new Date();
    const [SelectedDate, setSelectedDate] = useState(currentDate);
    const [submittedBy, setSubmittedBy] = useState('');
    const [submittedOn, setsubmittedOn] = useState('');
    const [isApprovalNotRequired, setIsApprovalNotRequired] = useState(false); // New state for Approval Not Required
    const [isCanvasLoader, setIsCanvasLoader] = useState(true);

    const getTimesheetApprovalDetail = () => {
        if (accountEmployeeTimeEntryPeriodId !== null) {
            fetchAPI(`api/v2/Timesheets/GetPeriodApprovalDetail/${accountEmployeeTimeEntryPeriodId}/${accountEmployeeId}`, 'GET')
                .then(res => res.json())
                .then((res) => {
                    if (res && res.length > 0) {
                        setDetail(res);
                    } else {
                        setDetail([]);
                    }
                }, (error) => console.log(error));
        }
    }

    useEffect(() => {
        if (timeEntryPeriodIdForApproval !== null && isApprovalDetail) {
            setDetail([]);
            dispatch(getAccountEmployeeTimeEntryDetailsAsync(accountEmployeeTimeEntryPeriodId))
                .unwrap()
                .then((originalPromiseResult) => {
                    if (originalPromiseResult.AccountEmployeeTimeEntry[0].PeriodSubmitted || originalPromiseResult.AccountEmployeeTimeEntry[0].PeriodRejected || originalPromiseResult.AccountEmployeeTimeEntry[0].PeriodApproved) {
                        setSubmittedBy(originalPromiseResult.AccountEmployeeTimeEntry[0].SubmittedByEmployeeName);
                        const submittedDate = originalPromiseResult.AccountEmployeeTimeEntry[0].PeriodSubmittedDate;
                        setsubmittedOn(submittedDate);
                        
                        // Backend response field mapping (e.g., IsApprovalNotRequired / ApprovalNotRequired)
                        setIsApprovalNotRequired(originalPromiseResult.AccountEmployeeTimeEntry[0].IsTimesheetAutoApproval ?? false);
                    }
                    else {
                        setSubmittedBy('');
                        setsubmittedOn('');
                        setIsApprovalNotRequired(false);
                    }
                })
                .catch((rejectedValueOrSerializedError) => {
                    console.log('Error', rejectedValueOrSerializedError);
                })
            getTimesheetApprovalDetail();
            setIsCanvasLoader(false);
        }
    }, [isLoading, !timeEntryPeriodIdForApproval]);





    const renderApprovalStatus = (approverStatus: any) => {
        let status: any = "";

        if (approverStatus.ApproverName === null) {
            status = (
                <span className="badge badge-light-success fs-7">
                    {getValueFromResource('Approved', dispatch, t)}
                </span>
            )
        }
        else if (approverStatus.IsApproved === true) {
            status = (
                <span className="badge badge-light-success fs-7">
                    {getValueFromResource('Approved', dispatch, t)}
                </span>
            )
        } else if (approverStatus.IsReject === true) {
            status = (
                <span className="badge badge-light-danger fs-7">
                    {getValueFromResource('Rejected', dispatch, t)}
                </span>
            )
        }

        return status;
    }

    return (
        <>
            {/* <div className="modal drawer-overlay" data-bs-backdrop="false" tabIndex={-1} id="timesheetApprovalDetails" role="dialog" aria-labelledby="exampleModalSizeSm" aria-hidden="true">
                <div className='modal-dialog modal-xl'>
                    <div className='modal-content rounded'> */}
                     <div className="modal drawer-overlay" data-bs-backdrop="false" tabIndex={-1} id="timesheetApprovalDetails"  role="dialog" aria-labelledby="exampleModalSizeSm" aria-hidden="true"
                
            >
                <div className="modal-dialog"
                    style={{
                        maxWidth: '70vw',
                        width: '70vw',
                        marginTop: '10px',
                    }}
                >
                    <div className="modal-content" style={{ borderRadius: '8px' }}>
                        <div className="modal-header pb-2">
                            <h3 className='modalheaderTitle'>
                                {getValueFromResource('Timesheet Approval Details', dispatch, t)}
                            </h3>
                            <div
                                className='btn btn-sm btn-icon btn-active-color-primary'
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            >
                                <KTIcon iconName='cross' className='fs-1' />
                            </div>
                        </div>
                        <div className='modal-body pt-0 pb-15 px-5 px-xl-5' style={{ overflowY: 'auto', maxHeight: 'calc(100vh - 300px)' }}>
                            {isCanvasLoader ? <CanvasLoader /> : <>
                            <div className="d-flex align-items-center justify-content-between w-100 py-4 px-10">
    {/* Item 1: Submitted By */}
    <div className="d-flex align-items-center">
        <div className="symbol symbol-36px me-3">
            <img src={toAbsoluteUrl('/media/svg/customSVG/icon-Employee.svg')} alt="Employee" />
        </div>
        <div className="d-flex flex-column text-start">
            <span className="text-gray-600 fs-7 fw-semibold">
                {getValueFromResource('Submitted By', dispatch, t)}
            </span>
            <span className="text-gray-800 fs-6 fw-bold mt-1">
                {submittedBy || '-'}
            </span>
        </div>
    </div>

    
    <div className="d-flex align-items-center">
        <div className="symbol symbol-36px me-3">
            <img src={toAbsoluteUrl('/media/svg/customSVG/icon-Date.svg')} alt="Submitted Date" />
        </div>
        <div className="d-flex flex-column text-start">
            <span className="text-gray-600 fs-7 fw-semibold">
                {getValueFromResource('Submitted On', dispatch, t)}
            </span>
            <span className="text-gray-800 fs-6 fw-bold mt-1">
                {submittedOn != null ? formatDateWithTZ(submittedOn, cultureInfoName.toString(), ProfileTimeZoneIANA) : '-'}
            </span>
        </div>
    </div>

    <div className="d-flex align-items-center">
        <div className="symbol symbol-36px me-3">
            <img src={toAbsoluteUrl('/media/svg/customSVG/icon-Approval.svg')} alt="Approval" />
        </div>
        <div className="d-flex flex-column text-start">
            <span className="text-gray-600 fs-7 fw-semibold">
                {getValueFromResource('Auto-Approve Timesheet', dispatch, t)}
            </span>
            <span className="text-gray-800 fs-6 fw-bold mt-1">
                {isApprovalNotRequired 
                    ? getValueFromResource('Yes', dispatch, t) 
                    : getValueFromResource('No', dispatch, t)
                }
            </span>
        </div>
    </div>
</div>
                              
                                <div className="custom-separator"></div>
                                <div className="table-responsive">
                                    <table className="table table-row-bordered align-middle gs-1 gy-1 gx-1">
                                        <thead>
                                            <tr className="tbheading align-middle">
                                                <th className='w-20' style={{ paddingLeft: '10px' }}>
                                                    {getValueFromResource('Approver Name', dispatch, t)}
                                                </th>
                                                <th className='w-15'>
                                                    {getValueFromResource('Approved On', dispatch, t)}
                                                </th>
                                                <th className='w-15'>
                                                    {getValueFromResource('Status', dispatch, t)}
                                                </th>
                                                <th className='w-20'>
                                                    {getValueFromResource('Comments', dispatch, t)}
                                                </th>
                                                <th className='w-15'>
                                                    {getValueFromResource('Projects', dispatch, t)}
                                                </th>
                                                 <th className='w-15'>
                                                    {getValueFromResource('Approval Type', dispatch, t)}
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {detail.length > 0 && detail.filter((x: any) => x.ProjectName != null).map((x: any, index: number) => (
                                                <tr key={index} style={{ height: 42 }}>
                                                    <td style={{ paddingLeft: '10px' }}>{x.ApproverName !== null ? x.ApproverName + " - " + x.SystemApproverType : 'System'}</td>
                                                    <td>
                                                        {x.ApprovedOn !== null ? formatDateWithTZ(moment.parseZone(x.ApprovedOn).format("YYYY-MM-DD"), cultureInfoName.toString(),ProfileTimeZoneIANA) : formatDateWithTZ(moment.parseZone(x.SubmittedDate).format("YYYY-MM-DD"), cultureInfoName.toString(), ProfileTimeZoneIANA)}
                                                    </td>
                                                    <td>
                                                        {renderApprovalStatus(x)}
                                                    </td>
                                                    <td>{x.Comments}</td>
                                                    <td>{x.ProjectName}</td>
                                                    <td>{x.ApprovalTypeName}</td>
                                                </tr>
                                            ))}

                                            {detail && detail.filter((x: any) => x.ProjectName != null).length === 0 &&
                                                <tr className={"text-center"} style={{ height: 42, marginLeft: '15px' }}>
                                                    <td colSpan={5}><p className='noDataFound'>
                                                        {getValueFromResource('No Record Found ', dispatch, t)}
                                                    </p></td>
                                                </tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </>
                            }
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary btn-sm"
                                data-bs-dismiss="modal"
                            >
                                {getValueFromResource('Cancel', dispatch, t)}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default TimeSheetApprovalDetails;